export const STATUS_MAPPING = {
    0: "Draft",
    1: "Submitted", 
    2: "Approved",
    3: "Rejected",
    4: "Published",
    5: "Scheduled",
    6: "Expired"
  };